import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { useTheme } from '@repo/shared';
import { useHistory ,useLocation} from "react-router-dom";
import 'reactjs-popup/dist/index.css';
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faClipboardList } from '@fortawesome/free-solid-svg-icons';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import NoData from '../common/NoData';
import LoadingSpinner from '../common/LoadingSpinner';
import StudentDataService from "../../services/student/StudentService";
import EventDataService from "../../services/event/EventService";
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import SortCaret from '../common/SortCaret';
import { ButtonMailto, ButtonIcon } from '../common/Buttons';

const EventsList = (props) => {
  const history = useHistory();
  const { appTheme } = useTheme();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filters, setFilters] = useState();

  const search = useLocation().search;

  useEffect(() => {
    document.title = `${appTheme?.appName} - Events`

    retrieveEvents();

  }, []);

  const retrieveEvents = () => {
    EventDataService.getAll()
      .then((response) => {
        //transform to add state field
        const transformedEvents = response.map(c => {
          const status = '';
          return { ...c, status};
        }).sort((a,b) => b.title.localeCompare(a.title));
        setEvents(transformedEvents);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  const addEvent = () => {
      history.push("event/");
  }
  const openEvent = (theEvent) => {
    console.log(theEvent);
    history.push("event/" + theEvent.id);
  };

  const takeAttendance = (event) => {
    const id = event.id;
    history.push(`attendance/event/${id}`);
  }

  const getEmailAddressesForEvent = async (eventId) => {
    console.log('Getting emailAddresses for event', eventId);

    const studentsForEvent = await StudentDataService.getAllForEvent(eventId);

    return studentsForEvent.map(s => s.emailAddress);
  }

  const getBodyForEventFullEmail = async (eventId) => {
    const fullEmail = await EventDataService.getEmailBody(eventId);
    console.log(fullEmail);
    return fullEmail;
  }

  const urlFilterRefs = useRef({});

  const createURLFilterConfig = useCallback((fieldName, currentSearch) => {
    return {
      defaultValue: new URLSearchParams(currentSearch).get(fieldName) || '',
      onFilter: (filterValue) => {
        console.log('Filter value changed:', filterValue);
        // Only update URL if the value actually changed from what we last pushed
        if (urlFilterRefs.current[fieldName] === filterValue) {
          return;
        }
        
        urlFilterRefs.current[fieldName] = filterValue;
        
        try {
          const params = new URLSearchParams(search);
          if (filterValue) {
            params.set(fieldName, filterValue);
          } else {
            params.delete(fieldName);
          }
          history.push(`?${params.toString()}`);
        } catch (error) {
          console.error('Error updating URL filter:', error);
        }
      }
    };
  }, [history, search]);

  const eventColumns = useMemo(() => [
    { sort: true, dataField: 'title', text: 'Title', filter: textFilter(), sortCaret: SortCaret },
    { sort: true, dataField: 'teacher', text: 'Teacher', filter: textFilter(createURLFilterConfig('teacher', search)), sortCaret: SortCaret },
    { sort: true, dataField: 'location', text: 'Location', filter: textFilter(), sortCaret: SortCaret },
    { sort: true, dataField: 'ageRange', text: 'Age Range', filter: textFilter(), sortCaret: SortCaret },
    { sort: true, dataField: 'active', text: 'Active', filter: textFilter(), sortCaret: SortCaret },
    {
      dataField: 'attendance',
      text: 'Attendance',
      editable: false,
      formatter: (cell, row) => (
        <ButtonIcon
          disabled={false}
          icon={<FontAwesomeIcon icon={faClipboardList}/>}
          onClick={async (e) => {
            e.stopPropagation();
            takeAttendance(row);
          }} />
      ),
      headerStyle: { width: '80px', textAlign: 'center' },
      align: 'center',
    },
    {
      dataField: 'introEmail',
      text: 'Intro Email',
      editable: false,
      formatter: (cell, row) => (
        <ButtonMailto
          sent={!!row.emailSentList}
          emailAddressesCallback={() => getEmailAddressesForEvent(row.id)}
          subject={`Message from ${appTheme?.appName} about event "${row.title}"`}
          confirmCallback={(resolveFunction) => confirmEmailSend(resolveFunction, row.emailSentList)}
          bodyCallback={() => getBodyForEventFullEmail(row.id)} />
      ),
      headerStyle: { width: '80px', textAlign: 'center' },
      align: 'center',
    }
  ], [events, createURLFilterConfig, appTheme]);

  const tableNoDataIndication = () => {
    if (loading) return <div className="p-4"><LoadingSpinner /></div>;
    return <NoData type="events" />;
  };

  return (
    <Container className="py-2 py-lg-4">
      <Row className="justify-content-center">
        <Col>
          <Card className="h-100 shadow-sm">
            <Card.Header className="d-flex align-items-center gap-2">
              <h2 className="mb-0">Events</h2>
              <div className="d-flex gap-2 ms-auto">
                <Button variant="primary" size="sm" onClick={addEvent}>
                  <FontAwesomeIcon icon={faPlus} className="me-2" /> Add Event
                </Button>
              </div>
            </Card.Header>
            <Card.Body className="p-0" style={{ overflowX: 'auto' }}>
              <BootstrapTable
                keyField='id'
                striped
                hover
                condensed
                data={events}
                columns={eventColumns}
                bordered={false}
                classes="mb-0"
                noDataIndication={tableNoDataIndication}
                filter={filterFactory()}
                rowEvents={{ onClick: (e, row) => openEvent(row) }}
              />
            </Card.Body>
            <Card.Footer className="text-muted">
              Showing {events.length} events.
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EventsList;